import React from 'react';
import Root from "./routes/root";

function App() {
  return (
    <div>
      <Root />
    </div>
  );
}

export default App;
